import { observable } from "mobx";
import { assert } from "@bonliva-crm/common";
import { StateMachine } from "@modules/mobx-state-machine";
import {
  BookingProfileFragment,
  BookingProfile_Get,
  GetBookingGroupSection
} from "@graphql";
import { client } from "@graphql/client";
import { store } from "@store";
import { Contact } from "@containers/ContactSelectorDialog";

type BookingProfileState =
  | "loading"
  | "initial"
  | "contactSelector"
  | "timereportApproval"
  | "sendTimereport"
  | "error";

export class BookingProfileStore {
  fsm = new StateMachine<BookingProfileState>("loading");
  @observable selectedContacts: Contact[] = [];
  @observable isContractEditorLoading = false;
  @observable bookingData: BookingProfileFragment;

  bookingId: string = "";

  error: string;

  constructor(public readonly id: string) {
    this.init(id);
    (window as any).bookingProfileStore = this;

    store().localPubSub.timereportUpdated.on(() => {
      setTimeout(() => this.fetch(true), 3000);
    });

    store().localPubSub.accommodationConfirmationUpdated.on(() => {
      setTimeout(() => this.fetch(true), 3000);
    });

    store().localPubSub.financeFormUpdated.on(() => {
      setTimeout(() => this.fetch(true), 3000);
    });
  }

  toInitial = (data?: BookingProfileFragment) => {
    if (data) {
      this.bookingData = data;
    }
    assert(this.bookingData, "booking data is not set");
    return this.fsm.transition("initial");
  };

  toSendTimereport = (contacts: Contact[]) => {
    this.selectedContacts = contacts;
    this.fsm.transition("sendTimereport");
  };

  toError = (err: Error | string, withSnackbar = true) => {
    this.error = err.toString();
    withSnackbar && store().snackbars.error(err.toString());
    this.fsm.transition("error");
  };

  fetch = (skipTransition = false) => {
    if (!skipTransition) {
      this.fsm.transition("loading");
    }

    BookingProfile_Get.func({ id: this.bookingId }, { fetchPolicy: "network-only" })
      .then(({ data }) => {
        if (!data.bookingById) {
          return this.toError("Booking doesn't exist", false);
        }

        if (data.bookingById.BookingGroup) {
          client.cache.writeQuery({
            query: GetBookingGroupSection.Document,
            data: {
              getBookingGroup: data.bookingById.BookingGroup
            },
            variables: {
              bookingGroupId: data.bookingById.BookingGroup._id
            }
          });
        }

        this.toInitial(data.bookingById);
      })
      .catch((e) => this.toError(e));
  };

  init = (bookingId: string) => {
    this.bookingId = bookingId;
    this.fetch();
  };
}
